import {registerSavedTrack} from '@gaia/utils/gaia/saveTrack';
import keyBy from 'lodash/keyBy';
import pickBy from 'lodash/pickBy';

import {createTrack} from './create';

export default function bulkArchive(
    action: BulkArchiveAction,
    setTracks: React.Dispatch<React.SetStateAction<{[trackLocalId: string]: Track}>>
) {
    if (!action.ids.length) return [];

    setTracks((latestTracks) => {
        let archivedTracks = action.ids.map((id) => {
            if (latestTracks[id]) {
                return {
                    ...latestTracks[id],
                    properties: {
                        ...latestTracks[id].properties,
                        archived: action.archived,
                    },
                };
            } else {
                // Create an empty track to make sure we don't show tracks
                // that have been deleted without being taken local
                const newTrack = createTrack();
                return {
                    ...newTrack,
                    properties: {
                        ...newTrack.properties,
                        localId: id,
                        id,
                        archived: true,
                        bulkArchived: true,
                    },
                };
            }
        });

        if (action.archived === false) {
            archivedTracks = archivedTracks.filter((track) => !track.properties.bulkArchived);
        }

        // calling registerSavedTrack directly is an escape hatch to prevent the
        // save effect from picking up this change
        archivedTracks.forEach((track) => registerSavedTrack(track));

        // If we are unarchiving, remove the partial local instance
        const existingTracks =
            action.archived === false
                ? pickBy(latestTracks, (track) => !track.properties.bulkArchived)
                : latestTracks;

        return {
            ...existingTracks,
            ...keyBy(archivedTracks, (track) => track.properties.localId),
        };
    });

    return action.ids;
}
